import script from "./AppGroupManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./AppGroupManagement.vue?vue&type=script&setup=true&lang=js"

import "./AppGroupManagement.vue?vue&type=style&index=0&id=471653e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471653e6"]])

export default __exports__